<template>
  <div class="custom-table">
    <div v-if="terminals" class="table-responsive">
      <table class="podft table table-striped table-hover table-row-dashed fs-7 table-row-gray-300 gy-3 mb-0 text-gray-800">
        <thead>
        <tr class="align-middle bg-gray-100i">
          <td colspan="8" class="text-center">
            <div
                @click="openModel(null, null, false)"
                class="rounded border border-dashed pt-6 pb-6 cursor-pointer text-gray-400 border-gray-300 text-hover-primary border-hover-primary" style="border-width: 1px;">Добавить</div>
          </td>
        </tr>
        <tr class="fw-bold fs-8 text-gray-400">
          <th class="w-60px">ID</th>
          <th class="w-125px">Терминал (Касса)</th>
          <th class="w-60px">Статус</th>
          <th>Ответственный</th>
          <th>Бухгалтер</th>
          <th style="width: 100px;">Действие</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in terminals">
          <td v-html="item.id"></td>
          <td v-html="item.terminal"></td>
          <td class="text-center">
            <span class="p-1 rounded" :class="item.status ? 'bg-success' : 'bg-danger'"></span>
          </td>
          <td v-html="item.login"></td>
          <td>
            <template v-if="item.accountant">
              {{item.accountant}}
            </template>
            <template v-else>
              <span class="px-3 py-1 rounded text-white fs-9 fw-bold bg-light-danger">
                <span class="text-danger">Не указан</span>
              </span>
            </template>
          </td>
          <td class="text-end">
            <span class="btn-activated cursor-pointer" @click="openModel(item.id, item.terminal, true)">
              <i class="ki-outline ki-notepad-edit text-primary fs-4"></i>
            </span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BranchTerminalsTable',
  props: {
    terminals: null
  },
  data() {
    return {
      loaded: false
    }
  },
  methods: {
    openModel(id, title, isEdit) {
      this.$store.dispatch('branchTerminalCreateUpdateModel', {id:id, title:title, isEdit: isEdit})
      new bootstrap.Modal('#branchTerminalCreateUpdateModel', {}).show()
    }
  }
}
</script>

<style scoped>

</style>